import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getFullNameUser } from "@/js/user/user.js";
import { getErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
export default {
  name: "orderCustomsInvoiceDialog",
  props: {
    order: Object
  },
  data: function data() {
    return {
      options: {
        color: "primary",
        width: 900,
        zIndex: 2000
      },
      shown: false,
      isLoadingData: false,
      saveCancellationToken: null,
      isValidating: false,
      isAdding: true,
      form: {
        valid: false,
        orderId: null,
        leftTitle: "Imported by",
        leftNameLine: null,
        leftPhoneLine: null,
        leftTaxIdLine: null,
        leftPermitLine: null,
        leftAddressLine1: null,
        leftAddressLine2: null,
        leftPartnerLine1: null,
        leftPartnerLine2: null,
        leftPartnerLine3: null,
        bottomTitle: null,
        bottomNameLine: null,
        bottomPhoneLine: null,
        bottomTaxIdLine: null,
        bottomPermitLine: null,
        bottomAddressLine1: null,
        bottomAddressLine2: null,
        bottomPartnerLine1: null,
        bottomPartnerLine2: null,
        bottomPartnerLine3: null,
        rightTitle: "Ship to",
        rightNameLine: null,
        rightPhoneLine: null,
        rightTaxIdLine: null,
        rightPermitLine: null,
        rightAddressLine1: null,
        rightAddressLine2: null,
        rightAddressLine3: null,
        rightAddressComplement: null,
        rightAddressCity: null,
        rightAddressCountry: null,
        rightPartnerLine1: null,
        rightPartnerLine2: null,
        rightPartnerLine3: null
      },
      formRules: formRules
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.form.orderId = +_this2.order.id_order;
            _context.next = 3;
            return _this2.fetch();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    confirm: function confirm() {
      this.shown = false;
      this.$emit("confirmed");
    },
    fetch: function fetch() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, _this3$order$billing_;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoadingData = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/orders/".concat(_this3.form.orderId, "/customs-invoice"), "get", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load custom data");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.close();
                throw e;
              });
            case 4:
              response = _context2.sent;
              if (response.data.value) {
                _this3.form = _objectSpread(_objectSpread({}, _this3.form), response.data.value);
                _this3.isAdding = false;
              } else {
                if (_this3.order.importer.id > 0) {
                  _this3.form.leftNameLine = _this3.order.importer.nameLine;
                  _this3.form.leftAddressLine1 = _this3.order.importer.addressLine1;
                  _this3.form.leftAddressLine2 = _this3.order.importer.addressLine2;
                  _this3.form.leftTaxIdLine = _this3.order.importer.taxIdLine;
                  _this3.form.leftPermitLine = _this3.order.importer.permitLine;
                  _this3.form.leftPartnerLine1 = _this3.order.importer.partnerLine1;
                  _this3.form.leftPartnerLine2 = _this3.order.importer.partnerLine2;
                  _this3.form.leftPartnerLine3 = _this3.order.importer.partnerLine3;
                  _this3.form.leftPhoneLine = _this3.order.importer.phoneLine;
                } else {
                  _this3.form.leftTitle = "Bill to";
                  _this3.form.leftNameLine = getFullNameUser(_this3.order.user);
                  _this3.form.leftAddressLine1 = "".concat(_this3.order.billing_address.street);
                  _this3.form.leftAddressLine2 = "".concat(_this3.order.billing_address.zip, " ").concat(_this3.order.billing_address.city, ", ");
                  _this3.form.leftAddressLine2 += (_this3$order$billing_ = _this3.order.billing_address.state) !== null && _this3$order$billing_ !== void 0 && _this3$order$billing_.state_label ? "".concat(_this3.order.billing_address.state.state_label, ", ") : "";
                  _this3.form.leftAddressLine2 += _this3.order.billing_address.country.printable_name;
                  if (_this3.order.user.vat_code) {
                    _this3.form.leftTaxIdLine = _this3.order.user.vat_code;
                  }
                  if (_this3.order.user.siren) {
                    _this3.form.leftPartnerLine1 = _this3.order.user.siren;
                  }
                }
                _this3.loadRightSideWithDeliveryAddress();
              }
              _this3.isLoadingData = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cleanBottomSide: function cleanBottomSide() {
      this.form.bottomTitle = null;
      this.form.bottomNameLine = null;
      this.form.bottomAddressLine1 = null;
      this.form.bottomAddressLine2 = null;
      this.form.bottomTaxIdLine = null;
      this.form.bottomPermitLine = null;
      this.form.bottomPartnerLine1 = null;
      this.form.bottomPartnerLine2 = null;
      this.form.bottomPartnerLine3 = null;
      this.form.bottomPhoneLine = null;
    },
    loadBottomSideWithImporter: function loadBottomSideWithImporter() {
      this.form.bottomTitle = "Seller";
      this.form.bottomNameLine = this.order.importer.nameLine;
      this.form.bottomAddressLine1 = this.order.importer.addressLine1;
      this.form.bottomAddressLine2 = this.order.importer.addressLine2;
      this.form.bottomTaxIdLine = this.order.importer.taxIdLine;
      this.form.bottomPermitLine = this.order.importer.permitLine;
      this.form.bottomPartnerLine1 = this.order.importer.partnerLine1;
      this.form.bottomPartnerLine2 = this.order.importer.partnerLine2;
      this.form.bottomPartnerLine3 = this.order.importer.partnerLine3;
      this.form.bottomPhoneLine = this.order.importer.phoneLine;
    },
    loadRightSideWithImporter: function loadRightSideWithImporter() {
      this.form.rightNameLine = this.order.importer.nameLine;
      this.form.rightAddressLine1 = this.order.importer.addressLine1;
      this.form.rightAddressLine2 = null;
      this.form.rightAddressLine3 = null;
      this.form.rightAddressComplement = null;
      this.form.rightAddressCity = this.order.importer.addressLine2;
      this.form.rightAddressCountry = null;
      this.form.rightTaxIdLine = this.order.importer.taxIdLine;
      this.form.rightPermitLine = this.order.importer.permitLine;
      this.form.rightPartnerLine1 = this.order.importer.partnerLine1;
      this.form.rightPartnerLine2 = this.order.importer.partnerLine2;
      this.form.rightPartnerLine3 = this.order.importer.partnerLine3;
      this.form.rightPhoneLine = this.order.importer.phoneLine;
    },
    loadRightSideWithDeliveryAddress: function loadRightSideWithDeliveryAddress() {
      var _this$order$delivery_;
      this.form.rightNameLine = getFullNameUser(this.order.user);
      this.form.rightAddressLine1 = this.order.delivery_address.street;
      this.form.rightAddressLine2 = this.order.delivery_address.address_line_2;
      this.form.rightAddressLine3 = this.order.delivery_address.address_line_3;
      this.form.rightAddressComplement = this.order.delivery_address.address_complement;
      this.form.rightAddressCity = "".concat(this.order.delivery_address.zip, " ").concat(this.order.delivery_address.city);
      this.form.rightAddressCountry = (_this$order$delivery_ = this.order.delivery_address.state) !== null && _this$order$delivery_ !== void 0 && _this$order$delivery_.state_label ? "".concat(this.order.delivery_address.state.state_label, ", ") : "";
      this.form.rightAddressCountry += this.order.delivery_address.country.printable_name;
      this.form.rightPermitLine = this.order.user.excise_code ? "License #: ".concat(this.order.user.excise_code) : null;
      this.form.rightTaxIdLine = null;
      this.form.rightPartnerLine1 = null;
      this.form.rightPartnerLine2 = null;
      this.form.rightPartnerLine3 = null;
      this.form.rightPhoneLine = null;
    },
    save: function save() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$saveCancellati;
        var verb, data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isValidating = true;
              (_this4$saveCancellati = _this4.saveCancellationToken) === null || _this4$saveCancellati === void 0 || _this4$saveCancellati.cancel();
              _this4.saveCancellationToken = axios.CancelToken.source();
              verb = _this4.isAdding ? "post" : "put";
              data = _objectSpread({}, _this4.form);
              delete data.valid;
              _this = _this4;
              _context3.next = 9;
              return request("/v1/orders/customs-invoice", verb, data, true, "api", null, _this.saveCancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                _this.isValidating = false;
                throw e;
              });
            case 9:
              _this4.isValidating = false;
              _this4.$toasted.show(_this4.isAdding ? "Custom data created" : "Custom data saved", {
                type: "success"
              });
              _this4.confirm();
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    remove: function remove() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this5;
              _context4.next = 3;
              return request("/v1/orders/".concat(_this5.form.orderId, "/customs-invoice"), "delete", null, true, "api", null).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to remove custom data");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
              });
            case 3:
              _this5.confirm();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};